import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams,useNavigate  } from 'react-router-dom';
import JoditEditor from "jodit-react";
import { ServerUrl } from '../../../../api/ServerUrl';
import { ProtectAPi } from '../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../tools/BackButton';

const FhihEdit = () => {
    const { id } = useParams();
    const editor = useRef(null);
    const httpCPage = ServerUrl;
    const { http } = ProtectAPi();
    const navigate = useNavigate();
    const [loader, setLoader] = useState('off');
    const [layoutTitle, setLayoutTitle] = useState('');
    const [layoutDescription, setLayoutDescription] = useState('');
    const [priority, setPriority] = useState('');
    const [layoutImage, setLayoutImage] = useState(null);
    const [imagePreview, setImagePreview] = useState('');
    const [imageAltText, setImageAltText] = useState('');
    const [slug, setSlug] = useState('');

    const [layoutTitleError, setLayoutTitleError] = useState('');
    const [layoutDescriptionError, setLayoutDescriptionError] = useState('');
    const [priorityError, setPriorityError] = useState('');
    const [layoutImageError, setLayoutImageError] = useState('');
    const [imageAltTextError, setImageAltTextError] = useState('');
    const [slugError, setSlugError] = useState('');

    useEffect(() => {
        http.get(`/get-single-fhih-layout/${id}`)
            .then(res => {
                setLayoutTitle(res.data.title);
                setLayoutDescription(res.data.description);
                setPriority(res.data.priority);
                setImageAltText(res.data.image_alt || '');
                setSlug(res.data.slug || '');

                if (res.data.image) {
                    setImagePreview(`${httpCPage}/backend/img/fhih/${res.data.image}`);
                }
            })
            .catch(error => {
                console.error('Error fetching layout:', error);
            });
    }, [id]);

    const submitForm = () => {
        setLoader('on');
        const formData = new FormData();
        formData.append('title', layoutTitle);
        formData.append('description', layoutDescription);
        formData.append('priority', priority);
        formData.append('image', layoutImage);
        formData.append('image_alt', imageAltText);
        formData.append('slug', slug);

        http.post(`/update-single-fhih-layout/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => {
            if (res.data.status === '422') {
                const errors = res.data.error;
                setLoader('off');
                setLayoutImageError(errors.image ? errors.image[0] : '');
                setLayoutTitleError(errors.title ? errors.title[0] : '');
                setLayoutDescriptionError(errors.description ? errors.description[0] : '');
                setPriorityError(errors.priority ? errors.priority[0] : '');
                setImageAltTextError(errors.image_alt ? errors.image_alt[0] : '');
                setSlugError(errors.slug ? errors.slug[0] : '');
            } else {
                setLoader('off');
                swal('Success', res.data.msg, 'success').then(() => {
                    navigate('/admin/pages/fhih');
                });
            }
        }).catch(error => {
            setLoader('off');
            console.error('Error:', error);
        });
    };


    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        setLayoutImage(selectedImage);
        const previewURL = URL.createObjectURL(selectedImage);
        setImagePreview(previewURL);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'layoutTitle') setLayoutTitle(value);
        else if (name === 'priority') setPriority(value);
    };

    const editorConfig = useMemo(() => ({
        readonly: false,
        placeholder: 'Start typing...',
        height: 400,
        uploader: {
            insertImageAsBase64URI: true
        }
    }), []);

    return (
        <div className="main-content">
            <section className="section">
                <div className="section-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-primary">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between">
                                        <h5>Edit Layout</h5>
                                        <BackButton />
                                    </div>
                                    <div className="card-body pb-0">
                                        <div className="row">

                                            {/* Image Upload */}
                                            <div className="col-md-6 mt-4">
                                                <label>Layout Image</label>
                                                <div className="logo-box">
                                                    <div className="logo">
                                                        <label htmlFor="layoutImage">
                                                            <div className="image-box border dottet p-2 rounded">
                                                                {imagePreview ? (
                                                                    <img src={imagePreview} className='img-fluid' alt="Preview" />
                                                                ) : (
                                                                    <img src="https://w7.pngwing.com/pngs/159/705/png-transparent-computer-computer-trademark-computer-logo.png" className='img-fluid' alt="Default" />
                                                                )}
                                                            </div>
                                                            <input type="file" id="layoutImage" className="form-control d-none" onChange={handleImageChange} />
                                                            <span className='btn btn-primary mt-1 w-100'>Upload Layout Image</span>
                                                            <span className='text-danger'>{layoutImageError}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Image Alt Text */}
                                            <div className="col-md-12 mt-4">
                                                <div className="form-group">
                                                    <label>Image Alt Text</label>
                                                    <input
                                                        type="text"
                                                        name="imageAltText"
                                                        value={imageAltText}
                                                        className="form-control"
                                                        placeholder="Image alt text"
                                                        onChange={(e) => setImageAltText(e.target.value)}
                                                    />
                                                    <span className='text-danger'>{imageAltTextError}</span>
                                                </div>
                                            </div>

                                            {/* Title */}
                                            <div className="col-md-12 mt-4">
                                                <div className="form-group">
                                                    <label>Title</label>
                                                    <input
                                                        type="text"
                                                        name="layoutTitle"
                                                        value={layoutTitle}
                                                        className="form-control"
                                                        placeholder="Layout title"
                                                        onChange={handleInputChange}
                                                    />
                                                    <span className='text-danger'>{layoutTitleError}</span>
                                                </div>
                                            </div>

                                            {/* Slug */}
                                            <div className="col-md-12 mt-4">
                                                <div className="form-group">
                                                    <label>Slug</label>
                                                    <input
                                                        type="text"
                                                        name="slug"
                                                        value={slug}
                                                        className="form-control"
                                                        placeholder="Slug (example: foot-health-info)"
                                                        onChange={(e) => setSlug(e.target.value)}
                                                    />
                                                    <span className='text-danger'>{slugError}</span>
                                                </div>
                                            </div>

                                            {/* Priority */}
                                            <div className="col-md-12 mt-2">
                                                <div className="form-group">
                                                    <label>Priority</label>
                                                    <input
                                                        type="number"
                                                        name="priority"
                                                        value={priority}
                                                        className="form-control"
                                                        placeholder="Priority"
                                                        onChange={handleInputChange}
                                                    />
                                                    <span className='text-danger'>{priorityError}</span>
                                                </div>
                                            </div>

                                            {/* Description */}
                                            <div className="col-md-12 mt-4">
                                                <label>Layout Description</label>
                                                <JoditEditor
                                                    ref={editor}
                                                    value={layoutDescription}
                                                    config={editorConfig}
                                                    tabIndex={1}
                                                    onBlur={newContent => setLayoutDescription(newContent)}
                                                    onChange={() => {}}
                                                />
                                                <span className='text-danger'>{layoutDescriptionError}</span>
                                            </div>


                                            {/* Submit Button */}
                                            <div className="col-md-12 mt-5 mb-4">
                                                {loader === 'off' ? (
                                                    <button type="submit" onClick={submitForm} className="btn btn-lg btn-primary">Update</button>
                                                ) : (
                                                    <div className="spinner-border text-dark" role="status"></div>
                                                )}
                                            </div>

                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FhihEdit;
